(ns ui.state.session.sub
  (:require
   [common.localization :as loc]

   ;; TODO remove these imports
   [frontend.state.current-session :as session]
   [frontend.db :as frontend-db]
   [potpuri.core :as p]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [reagent.ratom :as ratom]
   [ui.state.session.model :as model]))

(rf/reg-sub-raw
 ::entities
 (fn [db-atom _]
   (ratom/reaction
    (let [entities (model/get-entities @db-atom)]
      entities))))

(rf/reg-sub-raw
 ::legacy-entities
 (fn [_ _]
   (ratom/reaction
    @session/entities)))

;; @(rf/subscribe [::session-sub/entity entity-id]) is somewhat equivalent
;; to @(r/track session/get-entity entity-id) but also contains the re-frame
;; db entities
(rf/reg-sub
 ::entity
 :<- [::entities]
 :<- [::legacy-entities]
 (fn [[entities legacy-entities] [_ id]]
   (or (get entities id)
       (get legacy-entities id))))

(rf/reg-sub-raw
 ::tenant
 (fn [_ _]
   (ratom/reaction @session/tenant)))

(rf/reg-sub-raw
 ::default-vault-config
 (fn [_ _]
   (ratom/reaction @session/default-vault-config)))

(rf/reg-sub
 ::tenant-date-format
 :<- [::tenant]
 (fn [tenant]
   (or (:tenant/date-format tenant)
       (loc/tr :date-format))))

(rf/reg-sub-raw
 ::account
 (fn [_ _]
   (ratom/reaction @session/account)))

(rf/reg-sub-raw
 ::account-id
 (fn [_ _]
   (ratom/reaction @session/account-id)))

(rf/reg-sub
 ::flagged-entities
 :<- [::account]
 (fn [account]
   (-> account
       :account/flagged-entities
       set)))

(rf/reg-sub
 ::account-preferences
 :<- [::account]
 (fn [account]
   (:account/preferences account)))

(rf/reg-sub
 ::favorite-single-entity-views
 :<- [::account-preferences]
 (fn [account-preferences]
   (get account-preferences :favorite-single-entity-views {})))

(rf/reg-sub
 ::decision-configuration
 :<- [::tenant]
 (fn [tenant]
   (:tenant/decision-configuration tenant)))

(rf/reg-sub-raw
 ::role
 (fn [_ _]
   (ratom/reaction @session/role)))

(rf/reg-sub-raw
 ::current-permissions
 (fn [_ _]
   (ratom/reaction @session/current-permissions)))

(rf/reg-sub-raw
 ::tenant-schema
 (fn [_ _]
   (ratom/reaction @session/tenant-schema)))

(rf/reg-sub-raw
 ::tenant-users
 (fn [_ _]
   (ratom/reaction @(r/track session/tenant-users))))

(rf/reg-sub-raw
 ::dealflow?
 (fn [_ _]
   (ratom/reaction @(r/track session/dealflow?))))

(rf/reg-sub-raw
 ::fundraising?
 (fn [_ _]
   (ratom/reaction @(r/track session/fundraising?))))

(rf/reg-sub-raw
 ::portfolio?
 (fn [_ _]
   (ratom/reaction @(r/track session/portfolio?))))

(rf/reg-sub-raw
 ::sales-pipelines?
 (fn [_ _]
   (ratom/reaction @(r/track session/sales-pipelines?))))

(rf/reg-sub-raw
 ::feature-access?
 (fn [_ [_ feature]]
   (ratom/reaction @(r/track session/has-feature-access? feature))))

(rf/reg-sub-raw
 ::read-only-user?
 (fn [_ _]
   (ratom/reaction @(r/track session/is-read-only-user?))))

;; TODO: maybe better name and more granular access to different items
(rf/reg-sub
 ::session-context
 :<- [::account]
 :<- [::current-permissions]
 :<- [::role]
 :<- [::tenant]
 :<- [::tenant-schema]
 (fn [[account account-current-permissions role tenant tenant-schema]]
   {:account                     account
    :account-current-permissions account-current-permissions
    :role                        role
    :tenant                      tenant
    :tenant-schema               tenant-schema
    :tr                          loc/tr}))

(rf/reg-sub
 ::tenant-users-by-id
 :<- [::tenant-users]
 (fn [tenant-users]
   (p/index-by :db/id tenant-users)))

(rf/reg-sub
 ::entity-types
 :<- [::entities]
 (fn [entities _]
   (->> entities
        (vals)
        (group-by :entity/type))))

(rf/reg-sub
 ::entities-for-type
 :<- [::entity-types]
 (fn [entities-by-type [_ entity-type]]
   (get entities-by-type entity-type)))

(rf/reg-sub-raw
 ::server-url
 (fn [_]
   (ratom/reaction @frontend-db/server-url)))
